import { Link as OriginalLink } from "@tiptap/extension-link";

export const Link = OriginalLink.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      dataRef: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-ref") || undefined,
        renderHTML: (attributes) => {
          return {
            "data-ref": attributes.dataRef as string | null,
          };
        },
      },
    };
  },

  addOptions() {
    const parentOptions = this.parent?.();
    return {
      ...parentOptions,
      defaultProtocol: "https",
      HTMLAttributes: {
        ...parentOptions?.HTMLAttributes,
        class: "text-blue-500 cursor-pointer hover:underline",
      },
    };
  },
});
